import { effect as _$effect } from "@opentui/solid";
import { insert as _$insert } from "@opentui/solid";
import { setProp as _$setProp } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import open from "open";
/**
 * Link component that renders clickable hyperlinks.
 * Clicking anywhere on the link text opens the URL in the default browser.
 */
export function Link(props) {
  const displayText = props.children ?? props.href;
  return (() => {
    var _el$ = _$createElement("text");
    _$setProp(_el$, "onMouseUp", () => {
      open(props.href).catch(() => {});
    });
    _$insert(_el$, displayText);
    _$effect(_$p => _$setProp(_el$, "fg", props.fg, _$p));
    return _el$;
  })();
}